<template>
  <div id="pilot-insert-data">
    <basic-insert-data
      masterName="水先案内人"
      :inputTypes="inputTypes"
      :colorOptions="colorOptions"
      backTo="addon-port-master-pilot-master"
      @insertData="insertData"
      ref="basicInsertData"
    >
    </basic-insert-data>
  </div>
</template>

<script>

import BasicInsertData from "../components/BasicInsertData";
import { snakeCase } from "snake-case";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");

export default {
  components: {
    BasicInsertData
  },
  data() {
    return {
      inputTypes: [
        {
          label: "名称",
          inputType: "string",
          key: "name",
          regex: /.+/,
        },
        {
          label: "ふりがな",
          inputType: "string",
          key: "kana",
        },
        {
          label: "略称",
          inputType: "string",
          key: "short_name",
        },
        {
          label: "カラーコード",
          inputType: "color",
          key: "color",
        },
        {
          label: "備考",
          inputType: "textArea",
          key: "description",
        },
      ],
    }
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      colorOptions: state => state.colorOptions,
    }),
  },
  async created() {
    await this.fetchColors(this.selectedPort.id)
  },
  methods: {
    ...mapActions(["insertPilot", "fetchColors"]),
    async insertData(value) {
      let enterpriseColorId = value[value.findIndex(element => element.key == "color")].value.id
      let name = value[value.findIndex(element => element.key == "name")].value
      let kana = value[value.findIndex(element => element.key == "kana")].value
      let shortName = value[value.findIndex(element => element.key == "short_name")].value
      let description = value[value.findIndex(element => element.key == "description")].value
      let payload = {
        portId: this.selectedPort.id,
        body: {
          color_id: enterpriseColorId,
          keyboard_shortcut: "1", // TODO: 仮の値
          name: name,
          kana: kana,
          short_name: shortName,
          description: description,
          version: null
        }
      }
      try {
        this.$vs.loading()
        await this.insertPilot(payload)
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center"
        })
        this.$router.push(
          {
            path: "port-master-pilot-master"
          }
        )
      } catch(error) {
        if (error.code == "422") {
          let validationErrors = error.data.validation_results.map(element => {
            let targetKey = snakeCase(element.target)
            let index = this.inputTypes.findIndex(column => column.key == targetKey)
            let label = this.inputTypes[index].label
            let message = element.message
            return {
              label: label,
              message: message
            }
          })
          this.$refs.basicInsertData.openErrorPopup("エラー", null, validationErrors)
        } else {
          this.$refs.basicInsertData.openErrorPopup("エラー", error.message, null)
        }
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
